import { apiPost } from "../baseApi";
import { setCampusData } from "service/mapper";

export const create = async (data) => {
  try {
    const response = await apiPost("_campus", data);
    return { ...response, data: setCampusData(response.data) };
  } catch (error) {
    return Promise.reject(error);
  }
};
